<template>
  <div class="mt-4 w-full h-full bg-white">
    <div class="text-center mt-4" v-if="loading">
      <Spinner size="medium" line-fg-color="#00aba1" line-bg-color="#ccc" style="display: inline-block;"/>
      <span class="block">Loading...</span>
    </div>
    <Profile />
  </div>
</template>

<script>
import Spinner from 'vue-simple-spinner';
import Profile from '../components/Profile/Profile.vue';

export default {
  name: 'MerchantProfile',
  data() {
    return {
      loading: false,
    };
  },
  components: {
    Profile,
    Spinner,
  },
  async mounted() {
    this.setBreadCrumbs(this.$route.meta.breadCrumbs);
    try {
      this.loading = true;
      await this.$store.dispatch('SettingsModule/Config/fetchMerchantProfile');
      this.loading = false;
    } catch (e) {
      // TODO
      this.loading = false;
    }
  },
};
</script>

<style scoped>

</style>
